<template>
  <div class="price-list" v-loading.fullscreen.lock="loading">
    <top :title="title">
      <div>
        <a @click="toNewPage('/goods')" target="_blank" class="buy-btn">我要买</a>
        <a @click="toNewPage('/sell')" target="_blank" class="sell-btn" v-if="userInfo">我要卖</a>
        <a @click="showLogin" target="_blank" class="sell-btn" v-else>我要卖</a>
      </div>
    </top>
    <div class="con">
      <el-table :data="data" style="width: 100%" stripe border
      header-row-class-name="t-row" header-cell-class-name="t-cell">
        <el-table-column prop="account" label="会员账号" sortable align="center" class-name="t-hot">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
            <img v-if="scope.row.hot == 1" src="/static/img/hot.png" alt="" class="ic-hot">
            <span>{{scope.row.account}}</span>
          </template>
        </el-table-column>
        <template v-if="config_info.sale_extend!=='1'">
          <el-table-column prop="e_level" label="等级" sortable :formatter="formatterGrade" align="center"></el-table-column>
          <el-table-column v-if="config_info.finance_salary_status === '1'" prop="e_up_reward" label="等级礼金" sortable :formatter="formatterPrice" align="center"></el-table-column>
          <el-table-column v-if="config_info.week_salary_status === '1'" prop="e_week_reward" label="周俸禄" sortable :formatter="formatterPrice" align="center"></el-table-column>
          <el-table-column v-if="config_info.month_salary_status === '1'" prop="e_month_reward" label="月俸禄" sortable :formatter="formatterPrice" align="center"></el-table-column>
        </template>
        <template v-if="config_info.sale_extend==='1'">
          <el-table-column prop="vip_level" label="VIP等级" sortable :formatter="formatterGrade" align="center"></el-table-column>
          <el-table-column prop="e_level" label="电子等级" sortable :formatter="formatterGrade" align="center"></el-table-column>
          <el-table-column prop="r_level" label="真人等级" sortable :formatter="formatterGrade" align="center"></el-table-column>
        </template>
        <el-table-column prop="sale_price" label="标价" sortable :formatter="formatterPrice" align="center"></el-table-column>
        <el-table-column prop="id" label="详细资料" align="center" v-if="type==1">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
            <router-link :to="'acc-detail/' + scope.row.id" class="t-btn">详细资料</router-link>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="操作" align="center">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
            <a class="t-btn" v-if="type==1" @click="goBuy(scope.row)">立即购买</a>
            <span v-if="type==2" class="t-text">交易成功</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div class="p-l">
          <p class="total">共{{page.total_count}}条记录,{{page.total_page}}页,每页{{page.page_size}}条记录</p>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="page.page_current"
            :page-size="page.page_size"
            layout="prev, pager, next"
            :total="page.total_count"
            prev-text="上一页"
            next-text="下一页"
            >
          </el-pagination>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page.page_current"
          :page-size="page.page_size"
          layout="slot"
          :total="page.total_count"
          >
          <ul class="jumper">
            <li>每页显示:</li>
            <li v-for="item in sizes" v-bind:key="item.id" @click="handleSizeChange(item)">{{item}}</li>
          </ul>
        </el-pagination>
      </div>
    </div>
    <buy-dialog :info="cur_info" :tel="config_info.service_buy" ref="buyDialog" @submitbuy="submitBuy"></buy-dialog>
  </div>
</template>

<script>
import buyDialog from '@/components/buyDialog/buyDialog'
import top from '@/components/common/top/top'
import { mapState } from 'vuex'
import { buyResource } from '@/resource/resource'

const ERR_OK = 0

export default {
  name: 'pricelist',
  props: {
      title: {
        type: String
      },
      type: {
        type: Number,
        default: 1
      },
      data: {
        type: Array
      },
      page: {
        type: Object
      }
  },
  data () {
    return {
      currentPage: 1,
      cur_info: null,
      sizes: [20, 50, 100, 200],
      loading: false
    }
  },
  computed: {
    ...mapState(['userInfo', 'logined', 'config_info'])
  },
  created() {
    // console.log(this.page)
  },
  methods: {
    submitBuy(data) {
      this.loading = true
      buyResource.buy(data).then(res => {
        res = res.body
        this.loading = false
        if (res.errcode === ERR_OK) {
          this.$alert(res.data, '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$refs.buyDialog.showDialog(false)
              this.$refs.buyDialog.clearForm()
            }
          })
        }
      })
    },
    goBuy(row) {
      if (!this.userInfo) {
        this.showLogin()
      } else {
        this.cur_info = row
        this.$refs.buyDialog.showDialog(true)
      }
    },
    showLogin() {
      this.$emit('showlogin', true)
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
      this.$emit('changepagesize', val)
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.$emit('changepage', val)
    },
    toNewPage(url) {
      window.open(window.location.origin + url)
    },
    formatterGrade(row, column, cellValue, index) {
      return cellValue + '级'
    },
    formatterPrice(row, column, cellValue, index) {
      return '￥' + cellValue + '元'
    }
  },
  components: {
    top,
    buyDialog
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.price-list
  .con
    .page
      border solid 1px #dcdcdc
      border-top none
      display flex
      align-items center
      justify-content space-between
      height 42px
      .p-l
        display flex
        .total
          height 30px
          border solid 1px #dcdcdc
          padding 0 10px
          color #626262
          font-size 14px
          line-height 30px
          margin-left 5px
.yongligao .buy-btn
    background $red !important
.yongligao .sell-btn
    background $orange !important
.taiyangcheng018 .buy-btn
    background $red !important
.taiyangcheng018 .sell-btn
    background $orange !important
</style>



// WEBPACK FOOTER //
// priceList.vue?294807ba